import React from "react";
import styles from "../../../style/travelform.module.scss";

type FormVariant = "default" | "banner" | "popup";

interface TravelQuoteFormProps {
  variant?: FormVariant;
}

const TravelQuoteForm: React.FC<TravelQuoteFormProps> = ({
  variant = "default",
}) => {
  return (
    <form className={`${styles.form} ${styles[variant]}`}>
      <h2 className={styles.title}>Get the best Travel quotes now!</h2>

      <div className={styles.row}>
        <div className={styles.group}>
          <label htmlFor="origin">Flying from</label>
          <input type="text" id="origin" placeholder="Origin" name="origin" />
        </div>

        <div className={styles.group}>
          <label htmlFor="destination">Flying to</label>
          <input
            type="text"
            id="destination"
            placeholder="Destination"
            name="destination"
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.group}>
          <label htmlFor="departure">Departure</label>
          <input type="date" id="departure" name="departure" />
        </div>

        <div className={styles.group}>
          <label htmlFor="return">Return</label>
          <input type="date" id="return" name="return" />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.group}>
          <label htmlFor="class">Class</label>
          <select id="class" name="class">
            <option>Economy</option>
            <option>Business</option>
            <option>First</option>
          </select>
        </div>

        <div className={styles.group}>
          <label htmlFor="adult">Adult</label>
          <input
            type="number"
            id="adult"
            name="adult"
            min={1}
            defaultValue={1}
          />
        </div>

        <div className={styles.group}>
          <label htmlFor="child">Child</label>
          <input
            type="number"
            id="child"
            name="child"
            min={0}
            defaultValue={0}
          />
        </div>

        <div className={styles.group}>
          <label htmlFor="infant">Infant</label>
          <input
            type="number"
            id="infant"
            name="infant"
            min={0}
            defaultValue={0}
          />
        </div>
      </div>

      <button type="submit" className={styles.submit}>
        Next
      </button>
    </form>
  );
};

export default TravelQuoteForm;
